import { render, staticRenderFns } from "./exportrecord.vue?vue&type=template&id=5433c228&scoped=true"
import script from "./exportrecord.vue?vue&type=script&lang=ts"
export * from "./exportrecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5433c228",
  null
  
)

export default component.exports